import { html, render } from 'lit/html.js'
import { styleMap } from 'lit/directives/style-map.js'
import { StateElement } from '../unit-base'
import '../unit-svg/'

const signature = `
Element will change color on click and can display icon1 and icon2.

### Set State with Attributes and Properties
\`\`\`javascript
document.querySelector("unit-link").state = {
  // Attributes
  "id": null,
  "value": "url",
  "label": "Label",
  "disabled": false,
  "icon": ""
}
\`\`\`

### Events
\`\`\`javascript
document.querySelector("unit-link").addEventListener("action", (e) => {
  console.log(e.detail)
})
\`\`\`
`

export default class Link extends StateElement {

  constructor() {
    super()
  }

  static get signature() {
    return signature.trim()
  }

  static get observedAttributes() {
    return [ "id", "value", "label", "disabled", "icon" ]
  }

  template( data ) {
    const value = data.value || ""
    const label = data.label || ""
    const icon = !data.icon ? null : typeof data.icon == "string" ? { src: data.icon } : data.icon

    const onAction = ( e ) => {
      e.stopPropagation()
      e.preventDefault()
      // Check origin
      const origin = e.type == "action" ? e.target.className : "main"
      // Dispatch parent with state
      this.dispatchEvent( new CustomEvent( 'action', {
        bubbles: true,
        detail: { value: this.state.value, origin: e.target }
      } ) )
    }


    return html `
    <a @click="${onAction}" href="${ value }">
      <label>
      ${ icon
        ? html `<unit-svg class="icon1" .state=${icon}></unit-svg>`
        : ``
      }
      ${ label }</label>
    </a>


    `
  }

}